<template>
  <transition :name="'fade'" mode="out-in">
    <CustomReveal
      v-if="recoverPassword"
      :isVisible="recoverPassword"
      revealId="card"
      class="recover-password-modal"
      v-on:close-reveal-card="closeRecoverPasswordModal"
    >
      <div class="secondary-menu">
          <div class="secondary-menu-body recover-password" id="card" data-reveal2>
            <div id="application-wrapper">
              <section class="modal recover-password">
                <div class="inner">
                  <div class="section-header">
                    <i class="back" @click="closeModal"></i>
                  </div>
                  <div class="section-body">
                    <form id="recover__form" class="step" data-abide2 data-vv-scope="recoverForm"  @submit.prevent="submit">
                              <div class="form-inner">
                                <div class="headline">{{ trans('recover_password') }}</div>
                                 <label>
                                    <input
                                       type="email"
                                        v-model="email"
                                        id="email"
                                        name="email"
                                        class="form-control dark"
                                        :placeholder="trans('email')"
                                        :data-vv-as="trans('email')"
                                        v-validate="'required|email'"
                                        :class="{error: formErrors.email}"
                                        @input="emailChanged"
                                        required>

                                    <span class="form-error" v-show="errors.has('recoverForm.email')" :class="{'is-visible': errors.has('recoverForm.email')}">
                                        {{ errors.first('recoverForm.email') }}
                                    </span>
                                </label>
                              </div>
                             <div class="form-footer">

                               <button
                                   type="submit"
                                   class="btn btn-primary btn-rounded btn-long"
                                   id="button-recover"
                                   >
                                 {{trans('recover_now')}}
                               </button>

                               <a href="#" @click="help($event)">Need help?</a>
                             </div>
                           </form>


                  </div>
                </div>
              </section>
            </div>
          </div>
      </div>
    </CustomReveal>
  </transition>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';

export default {
  name: "RecoverPasswordModal",
  components: {
      CustomReveal
  },
  mixins: [require('@general/lib/mixin').default],
  data() {
    return {
      email: null,
      process: false,

      formErrors: {
          email: null
      }
    }
  },
  computed: {
      ...mapState({
          recoverPassword: state => state.modal.recoverPassword
      })
  },
  methods: {
      ...mapActions({
          recoverPasswordStart: 'recoverPasswordStart'
      }),
      help(event) {
        if (typeof zE != "undefined") {
          event.preventDefault()
          zE.activate()
        }else{
          console.log('ZE not exists');
        }
      },
      emailChanged(){
          if (this.formErrors.email) {
              this.formErrors.email = null
          }
      },
      validate(){
          let valid = true
          if (!this.email) {
              this.formErrors.email = true
              valid = false
          }

          const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!re.test(String(this.email).toLowerCase())) {
              this.formErrors.email = true
              valid = false
          }

          return valid
      },
      async sendRequest(){
          this.process = true
          this.showLoadingButton('#button-recover');
          try {
              let response = await this.recoverPasswordStart({
                  email: this.email
              })
              console.log('[Password Reset Form] Result', { response })

              this.process = false
              this.restoreLoadingButton('#button-recover')
              if (response !== false) {
                  console.log('[Password Reset Form] Success')
                  this.showSuccessNotification(response.message)
              }
          } catch (error) {
              console.log('[Password Reset Form] Error', { error })
          }
          this.restoreLoadingButton('#button-recover')

          this.process = false
      },
      submit(){
          console.log('[Password Reset Form] Submit')
          if (this.validate()){
              this.sendRequest()
          }
      },
      closeModal(fallback) {
         this.closeRecoverPasswordModal();
      }
  }
}
</script>